// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import FilledImageCard from "examples/Cards/InfoCards/FilledImageCard";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bomba_landing.jpg";
import waves from "assets/images/shapes/waves-white.svg"

import prods from "pages/data/productos"
import sects from "pages/data/sectores"

function Presentation() {
  const productos = prods.map(({ titulo, image, producto, width }) => (
    <Grid item xs={12} md={4} sx={{ mb: 2 }} key={titulo} >
      <FilledImageCard
        variant="contained"
        color="info"
        image={image}
        title={titulo}
        description=""
        producto={producto}
        action={{
            label: "¡Conoce más!",
        }}
        width={width}
      />
    </Grid>
  ));

  const sectores = sects.map(({ icon, title, description }) => (
    <Grid item xs={12} lg={4} key={title}>
      <FilledInfoCard
        color="info"
        icon={icon}
        title={title}
        description={description}
      />
    </Grid>
  ));

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <Grid item xs={12} lg={12}>
              <MKTypography
                variant="h1"
                color="white"
                textAlign="center"
                sx={{
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 1)',
                }}
              >
                Ares{" "}
              </MKTypography>
            </Grid>
            <Grid item xs={12} lg={12}>
              <MKTypography
                variant="body1"
                color="white"
                textAlign="center"
                sx={{
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 1)',
                }}
              >
                Abastecedora de refacciones y servicios.
              </MKTypography>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              alignItems="center"
              sx={{ my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h3" fontWeight="bold" color="#537aba" style={{textAlign: "center", marginBottom: "30px"}}>
                Somos una empresa de equipo de bombeo industrial, manejamos las mejores marcas originales y genéricas (OEM) del mercado.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{textAlign: "justify", marginBottom: "20px"}}>
                En ARES estamos orgullosos de la empresa que hemos creado como proveedor 100% mexicano dedicado a la venta de equipo de bombeo. Somos una empresa de equipo industrial que siempre está presente con los valores de la responsabilidad, la mejora continua y la calidad interna y externa. entregamos y trabajamos con empresas de los 32 estados de la república y tenemos una respuesta asegurada de menos de 30 minutos para desarrollar y darte una cotización.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{textAlign: "justify"}}>
                En ARES empujamos la excelencia con el cliente para impulsar el futuro y desafiar a la industria de las bombas, desafiándose día con día para ser más confiable, eficiente y responsable ante nuestros clientes y la economía. Es un futuro nuevo y emocionante cuando “Trabajo” e “Innovación” se encuentran avanzando en pro de la industria.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <MKBox
          display="flex"
          alignItems="center"
          borderRadius="xl"
          my={2}
          py={6}
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url(${waves})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Container>
            <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
              <Grid item xs={12} lg={12} sx={{ ml: "auto" }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      color="#ffffff"
                      icon="forum"
                      title="Asesoría de expertos y respuesta rápida"
                      description="Nuestros ingenieros y especialistas en equipo de bombeo te brindarán la mejor solución en función a tu aplicación y proyecto."
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      color="#ffffff"
                      icon="local_shipping"
                      title="Entrega extendida en todo méxico"
                      description="Entregamos nuestro equipos y accesorios en todo México. Además en casi todos nuestros productos contamos con plazos de entrega rápidos."
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      color="#ffffff"
                      icon="perm_phone_msg"
                      title="Alta capacidad de servicio industrial"
                      description="Ofrecemos una división de servicio técnico con ingenieros calificados y técnicos de servicio con capacidad para manejar proyectos complejos en toda industria."
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      color="#ffffff"
                      icon="stars"
                      title="Calidad garantizada en todos nuestros productos"
                      description="Comprometidos con la satisfacción de todos nuestros clientes, lo que da como resultado un alto servicio garantizado nuestros equipos de bombeo y refaccionamiento."
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox component="section">
          <Container>
            <Grid
              container
              item
              xs={12}
              lg={6}
              flexDirection="column"
              alignItems="center"
              sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h2" fontWeight="bold">
                Nuestros productos
              </MKTypography>
            </Grid>
          </Container>
          <Container sx={{ mt: 6 }}>
            <Grid container spacing={3} sx={{ mb: 10 }}>
              <Grid item xs={12} lg={12}>
                <Grid container spacing={3} justifyContent="center">
                  {productos}
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <Container>
          <Grid container spacing={3}>
            {sectores}
          </Grid>
        </Container>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
